"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersGroupResetButton = void 0;
var React = require("react");
var webexUI_1 = require("webexUI");
var __1 = require("../..");
var tooltipModifiers = [
    {
        name: 'offset',
        options: {
            offset: [-2, 0],
        },
    },
];
var FiltersGroupResetButton = function (_a) {
    var _b, _c;
    var visible = _a.visible, onResetClick = _a.onResetClick;
    if (!visible)
        return null;
    return (React.createElement("button", { type: "button", className: "clear-filters-button", onClick: onResetClick, "aria-label": (_b = __1.PageContext === null || __1.PageContext === void 0 ? void 0 : __1.PageContext.dictionary) === null || _b === void 0 ? void 0 : _b.resetBtnLabel },
        React.createElement(webexUI_1.Tooltip, { placement: "left", id: "search-filter-clear", contentClassName: "search-filters__clear-all-text", content: (_c = __1.PageContext === null || __1.PageContext === void 0 ? void 0 : __1.PageContext.dictionary) === null || _c === void 0 ? void 0 : _c.resetBtnLabel, modifiers: tooltipModifiers, isPortalRendering: true },
            React.createElement("span", { className: "icon icon-cancel" }))));
};
exports.FiltersGroupResetButton = FiltersGroupResetButton;
